function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { __awaiter } from "tslib";
import { DataItem } from "../../../core/render/Component";
import { Series } from "../../../core/render/Series";
import { List } from "../../../core/util/List";
import { Container } from "../../../core/render/Container";
import { Graphics } from "../../../core/render/Graphics";
import * as $type from "../../../core/util/Type";
import * as $object from "../../../core/util/Object";
import * as $array from "../../../core/util/Array";
import * as $utils from "../../../core/util/Utils";
/**
 * @ignore
 */
function min(left, right) {
  if (left == null) {
    return right;
  } else if (right == null) {
    return left;
  } else if (right < left) {
    return right;
  } else {
    return left;
  }
}
/**
 * @ignore
 */
function max(left, right) {
  if (left == null) {
    return right;
  } else if (right == null) {
    return left;
  } else if (right > left) {
    return right;
  } else {
    return left;
  }
}
/**
 * A base class for all XY chart series.
 *
 * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/series/} for more info
 */
export var XYSeries = /*#__PURE__*/function (_Series) {
  _inherits(XYSeries, _Series);
  var _super2 = _createSuper(XYSeries);
  function XYSeries() {
    var _this;
    _classCallCheck(this, XYSeries);
    _this = _super2.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this), "_xField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_yField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_xOpenField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_yOpenField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_xLowField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_xHighField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_yLowField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_yHighField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_axesDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_stackDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_selectionProcessed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_dataSets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(_assertThisInitialized(_this), "_mainContainerMask", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_x", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_y", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    /**
     * A [[Container]] that us used to put series' elements in.
     *
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "mainContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.children.push(Container.new(_this._root, {}))
    });
    /**
     * A list of axis ranges that affect the series.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-ranges/} for more info
     */
    Object.defineProperty(_assertThisInitialized(_this), "axisRanges", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new List()
    });
    Object.defineProperty(_assertThisInitialized(_this), "_skipped", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_couldStackTo", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(_assertThisInitialized(_this), "_reallyStackedTo", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(_assertThisInitialized(_this), "_stackedSeries", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(_assertThisInitialized(_this), "_aLocationX0", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_aLocationX1", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(_assertThisInitialized(_this), "_aLocationY0", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_aLocationY1", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(_assertThisInitialized(_this), "_showBullets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(_assertThisInitialized(_this), "valueXFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: ["valueX", "openValueX", "lowValueX", "highValueX"]
    });
    Object.defineProperty(_assertThisInitialized(_this), "valueYFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: ["valueY", "openValueY", "lowValueY", "highValueY"]
    });
    Object.defineProperty(_assertThisInitialized(_this), "_valueXFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_valueYFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    // used for full min/max
    Object.defineProperty(_assertThisInitialized(_this), "_valueXShowFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_valueYShowFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    // used for selection (uses working)
    Object.defineProperty(_assertThisInitialized(_this), "__valueXShowFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "__valueYShowFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_emptyDataItem", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new DataItem(_assertThisInitialized(_this), undefined, {})
    });
    Object.defineProperty(_assertThisInitialized(_this), "_dataSetId", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_tooltipFieldX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_tooltipFieldY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    return _this;
  }
  _createClass(XYSeries, [{
    key: "_afterNew",
    value: function _afterNew() {
      var _this2 = this;
      this.fields.push("categoryX", "categoryY", "openCategoryX", "openCategoryY");
      this.valueFields.push("valueX", "valueY", "openValueX", "openValueY", "lowValueX", "lowValueY", "highValueX", "highValueY");
      this._setRawDefault("vcx", 1);
      this._setRawDefault("vcy", 1);
      // this can't go to themes, as data might be parsed before theme
      this._setRawDefault("valueXShow", "valueXWorking");
      this._setRawDefault("valueYShow", "valueYWorking");
      this._setRawDefault("openValueXShow", "openValueXWorking");
      this._setRawDefault("openValueYShow", "openValueYWorking");
      this._setRawDefault("lowValueXShow", "lowValueXWorking");
      this._setRawDefault("lowValueYShow", "lowValueYWorking");
      this._setRawDefault("highValueXShow", "highValueXWorking");
      this._setRawDefault("highValueYShow", "highValueYWorking");
      this._setRawDefault("lowValueXGrouped", "low");
      this._setRawDefault("lowValueYGrouped", "low");
      this._setRawDefault("highValueXGrouped", "high");
      this._setRawDefault("highValueYGrouped", "high");
      _get(_getPrototypeOf(XYSeries.prototype), "_afterNew", this).call(this);
      this._settings.xAxis.series.push(this);
      this._settings.yAxis.series.push(this);
      this.set("maskContent", true);
      this._disposers.push(this.axisRanges.events.onAll(function (change) {
        if (change.type === "clear") {
          $array.each(change.oldValues, function (axisRange) {
            _this2._removeAxisRange(axisRange);
          });
        } else if (change.type === "push") {
          _this2._processAxisRange(change.newValue);
        } else if (change.type === "setIndex") {
          _this2._processAxisRange(change.newValue);
        } else if (change.type === "insertIndex") {
          _this2._processAxisRange(change.newValue);
        } else if (change.type === "removeIndex") {
          _this2._removeAxisRange(change.oldValue);
        } else if (change.type === "moveIndex") {
          _this2._processAxisRange(change.value);
        } else {
          throw new Error("Unknown IStreamEvent type");
        }
      }));
      var xAxis = this.get("xAxis");
      var yAxis = this.get("yAxis");
      this._disposers.push(xAxis.events.on("positionchanged", function () {
        _this2._fixPosition();
      }));
      this._disposers.push(yAxis.events.on("positionchanged", function () {
        _this2._fixPosition();
      }));
      if (!this.get("baseAxis")) {
        if (yAxis.isType("CategoryAxis") || yAxis.isType("DateAxis")) {
          this.set("baseAxis", yAxis);
        } else {
          this.set("baseAxis", xAxis);
        }
      }
      this.states.create("hidden", {
        opacity: 1,
        visible: false
      });
      this._makeFieldNames();
    }
  }, {
    key: "_processAxisRange",
    value: function _processAxisRange(axisRange) {
      var container = Container.new(this._root, {});
      axisRange.container = container;
      this.children.push(container);
      axisRange.series = this;
      var axisDataItem = axisRange.axisDataItem;
      axisDataItem.setRaw("isRange", true);
      var axis = axisDataItem.component;
      if (axis) {
        axis._processAxisRange(axisDataItem, ["range", "series"]);
        var bullet = axisDataItem.get("bullet");
        if (bullet) {
          var sprite = bullet.get("sprite");
          if (sprite) {
            sprite.setPrivate("visible", false);
          }
        }
        var axisFill = axisDataItem.get("axisFill");
        if (axisFill) {
          container.set("mask", axisFill);
        }
        axis._seriesAxisRanges.push(axisDataItem);
      }
    }
  }, {
    key: "_removeAxisRange",
    value: function _removeAxisRange(axisRange) {
      var axisDataItem = axisRange.axisDataItem;
      var axis = axisDataItem.component;
      axis.disposeDataItem(axisDataItem);
      $array.remove(axis._seriesAxisRanges, axisDataItem);
      var container = axisRange.container;
      if (container) {
        container.dispose();
      }
    }
  }, {
    key: "_updateFields",
    value: function _updateFields() {
      var _this3 = this;
      _get(_getPrototypeOf(XYSeries.prototype), "_updateFields", this).call(this);
      this._valueXFields = [];
      this._valueYFields = [];
      this._valueXShowFields = [];
      this._valueYShowFields = [];
      this.__valueXShowFields = [];
      this.__valueYShowFields = [];
      if (this.valueXFields) {
        $array.each(this.valueXFields, function (key) {
          var field = _this3.get(key + "Field");
          if (field) {
            _this3._valueXFields.push(key);
            var _field = _this3.get(key + "Show");
            _this3.__valueXShowFields.push(_field);
            if (_field.indexOf("Working") != -1) {
              _this3._valueXShowFields.push(_field.split("Working")[0]);
            } else {
              _this3._valueXShowFields.push(_field);
            }
          }
        });
      }
      if (this.valueYFields) {
        $array.each(this.valueYFields, function (key) {
          var field = _this3.get(key + "Field");
          if (field) {
            _this3._valueYFields.push(key);
            var _field2 = _this3.get(key + "Show");
            _this3.__valueYShowFields.push(_field2);
            if (_field2.indexOf("Working") != -1) {
              _this3._valueYShowFields.push(_field2.split("Working")[0]);
            } else {
              _this3._valueYShowFields.push(_field2);
            }
          }
        });
      }
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      _get(_getPrototypeOf(XYSeries.prototype), "_dispose", this).call(this);
      var chart = this.chart;
      if (chart) {
        chart.series.removeValue(this);
      }
      $array.removeFirst(this.get("xAxis").series, this);
      $array.removeFirst(this.get("yAxis").series, this);
    }
    // TODO use  SelectKeys<this["_privateSettings"], number | undefined>
  }, {
    key: "_min",
    value: function _min(key, value) {
      var newValue = min(this.getPrivate(key), value);
      this.setPrivate(key, newValue);
    }
    // TODO use  SelectKeys<this["_privateSettings"], number | undefined>
  }, {
    key: "_max",
    value: function _max(key, value) {
      var newValue = max(this.getPrivate(key), value);
      this.setPrivate(key, newValue);
    }
  }, {
    key: "_shouldMakeBullet",
    value: function _shouldMakeBullet(dataItem) {
      var xAxis = this.get("xAxis");
      var yAxis = this.get("yAxis");
      var baseAxis = this.get("baseAxis");
      if (!xAxis.inited || !yAxis.inited) {
        return false;
      }
      var minBulletDistance = this.get("minBulletDistance", 0);
      if (minBulletDistance > 0) {
        var startIndex = this.startIndex();
        var endIndex = this.endIndex();
        var count = endIndex - startIndex;
        if (xAxis == baseAxis) {
          if (xAxis.get("renderer").axisLength() / count < minBulletDistance / 5) {
            return false;
          }
        } else if (yAxis == baseAxis) {
          if (yAxis.get("renderer").axisLength() / count < minBulletDistance / 5) {
            return false;
          }
        }
      }
      if (dataItem.get(this._xField) != null && dataItem.get(this._yField) != null) {
        return true;
      }
      return false;
    }
  }, {
    key: "_makeFieldNames",
    value: function _makeFieldNames() {
      var xAxis = this.get("xAxis");
      var yAxis = this.get("yAxis");
      var xName = xAxis.getPrivate("name");
      var xCapName = $utils.capitalizeFirst(xName);
      var yName = yAxis.getPrivate("name");
      var yCapName = $utils.capitalizeFirst(yName);
      var xLetter = xAxis.get("renderer").getPrivate("letter");
      var yLetter = yAxis.get("renderer").getPrivate("letter");
      var open = "open";
      var low = "low";
      var high = "high";
      var show = "Show";
      if (xAxis.className === "ValueAxis") {
        this._xField = this.get(xName + xLetter + show);
        this._xOpenField = this.get(open + xCapName + xLetter + show);
        this._xLowField = this.get(low + xCapName + xLetter + show);
        this._xHighField = this.get(high + xCapName + xLetter + show);
      } else {
        this._xField = xName + xLetter;
        this._xOpenField = open + xCapName + xLetter;
        this._xLowField = low + xCapName + xLetter;
        this._xHighField = high + xCapName + xLetter;
      }
      if (yAxis.className === "ValueAxis") {
        this._yField = this.get(yName + yLetter + show);
        this._yOpenField = this.get(open + yCapName + yLetter + show);
        this._yLowField = this.get(low + yCapName + yLetter + show);
        this._yHighField = this.get(high + yCapName + yLetter + show);
      } else {
        this._yField = yName + yLetter;
        this._yOpenField = open + yCapName + yLetter;
        this._yLowField = low + yCapName + yLetter;
        this._yHighField = high + yCapName + yLetter;
      }
    }
  }, {
    key: "_fixVC",
    value: function _fixVC() {
      var xAxis = this.get("xAxis");
      var yAxis = this.get("yAxis");
      var baseAxis = this.get("baseAxis");
      var hiddenState = this.states.lookup("hidden");
      var sequencedInterpolation = this.get("sequencedInterpolation");
      if (hiddenState) {
        var value = 0;
        if (sequencedInterpolation) {
          value = 0.999999999999; // makes animate, good for stacked
        }

        if (xAxis === baseAxis) {
          hiddenState.set("vcy", value);
        } else if (yAxis === baseAxis) {
          hiddenState.set("vcx", value);
        } else {
          hiddenState.set("vcy", value);
          hiddenState.set("vcx", value);
        }
      }
    }
  }, {
    key: "_handleMaskBullets",
    value: function _handleMaskBullets() {
      if (this.isDirty("maskBullets")) {
        this.bulletsContainer.set("maskContent", this.get("maskBullets"));
      }
    }
  }, {
    key: "_fixPosition",
    value: function _fixPosition() {
      var xAxis = this.get("xAxis");
      var yAxis = this.get("yAxis");
      this.set("x", xAxis.x() - $utils.relativeToValue(xAxis.get("centerX", 0), xAxis.width()) - xAxis.parent.get("paddingLeft", 0));
      this.set("y", yAxis.y() - $utils.relativeToValue(yAxis.get("centerY", 0), yAxis.height()) - yAxis.parent.get("paddingTop", 0));
      this.bulletsContainer.set("y", this.y());
      this.bulletsContainer.set("x", this.x());
    }
  }, {
    key: "_prepareChildren",
    value: function _prepareChildren() {
      var _this4 = this;
      _get(_getPrototypeOf(XYSeries.prototype), "_prepareChildren", this).call(this);
      if (this.isDirty("valueYShow") || this.isDirty("valueXShow" || this.isDirty("openValueYShow") || this.isDirty("openValueXShow") || this.isDirty("lowValueYShow") || this.isDirty("lowValueXShow") || this.isDirty("highValueYShow") || this.isDirty("highValueXShow"))) {
        this._updateFields();
        this._makeFieldNames();
        this._valuesDirty = true;
      }
      this.set("width", this.get("xAxis").width());
      this.set("height", this.get("yAxis").height());
      this._handleMaskBullets();
      var xAxis = this.get("xAxis");
      var yAxis = this.get("yAxis");
      var baseAxis = this.get("baseAxis");
      var tooltipPositionX = this.get("tooltipPositionX");
      var tooltipFieldX;
      switch (tooltipPositionX) {
        case "open":
          tooltipFieldX = this._xOpenField;
          break;
        case "low":
          tooltipFieldX = this._xLowField;
          break;
        case "high":
          tooltipFieldX = this._xHighField;
          break;
        default:
          tooltipFieldX = this._xField;
      }
      this._tooltipFieldX = tooltipFieldX;
      var tooltipPositionY = this.get("tooltipPositionY");
      var tooltipFieldY;
      switch (tooltipPositionY) {
        case "open":
          tooltipFieldY = this._yOpenField;
          break;
        case "low":
          tooltipFieldY = this._yLowField;
          break;
        case "high":
          tooltipFieldY = this._yHighField;
          break;
        default:
          tooltipFieldY = this._yField;
      }
      this._tooltipFieldY = tooltipFieldY;
      if (this.isDirty("baseAxis")) {
        this._fixVC();
      }
      this._fixPosition();
      var stacked = this.get("stacked");
      if (this.isDirty("stacked")) {
        if (stacked) {
          if (this._valuesDirty && !this._dataProcessed) {} else {
            this._stack();
          }
        } else {
          this._unstack();
        }
      }
      if (this._valuesDirty && !this._dataProcessed) {
        this._dataProcessed = true;
        if (stacked) {
          this._stack();
        }
        $array.each(this.dataItems, function (dataItem) {
          $array.each(_this4._valueXShowFields, function (key) {
            var value = dataItem.get(key);
            if (value != null) {
              if (stacked) {
                value += _this4.getStackedXValue(dataItem, key);
              }
              _this4._min("minX", value);
              _this4._max("maxX", value);
            }
          });
          $array.each(_this4._valueYShowFields, function (key) {
            var value = dataItem.get(key);
            if (value != null) {
              if (stacked) {
                value += _this4.getStackedYValue(dataItem, key);
              }
              _this4._min("minY", value);
              _this4._max("maxY", value);
            }
          });
          xAxis.processSeriesDataItem(dataItem, _this4._valueXFields);
          yAxis.processSeriesDataItem(dataItem, _this4._valueYFields);
        });
        xAxis._seriesValuesDirty = true;
        yAxis._seriesValuesDirty = true;
        if (!this.get("ignoreMinMax")) {
          if (this.isPrivateDirty("minX") || this.isPrivateDirty("maxX")) {
            xAxis.markDirtyExtremes();
          }
          if (this.isPrivateDirty("minY") || this.isPrivateDirty("maxY")) {
            yAxis.markDirtyExtremes();
          }
        }
        this._markStakedDirtyStack();
        //this.updateLegendMarker(undefined); // causes legend marker to change color instantly when on
        if (!this.get("tooltipDataItem")) {
          this.updateLegendValue(undefined);
        }
      }
      if (this.isDirty("vcx") || this.isDirty("vcy")) {
        this._markStakedDirtyStack();
      }
      if (!this._dataGrouped) {
        xAxis._groupSeriesData(this);
        yAxis._groupSeriesData(this);
        this._dataGrouped = true;
      }
      if (this._valuesDirty || this.isPrivateDirty("startIndex") || this.isPrivateDirty("endIndex") || this.isDirty("vcx") || this.isDirty("vcy") || this._stackDirty) {
        var startIndex = this.startIndex();
        var endIndex = this.endIndex();
        var minBulletDistance = this.get("minBulletDistance", 0);
        if (minBulletDistance > 0 && baseAxis) {
          if (baseAxis.get("renderer").axisLength() / (endIndex - startIndex) > minBulletDistance) {
            this._showBullets = true;
          } else {
            this._showBullets = false;
          }
        }
        if ((this._psi != startIndex || this._pei != endIndex || this.isDirty("vcx") || this.isDirty("vcy") || this._stackDirty || this._valuesDirty) && !this._selectionProcessed) {
          this._selectionProcessed = true;
          var vcx = this.get("vcx", 1);
          var vcy = this.get("vcy", 1);
          var _stacked = this.get("stacked", false);
          var outOfSelection = this.getPrivate("outOfSelection");
          if (baseAxis === xAxis) {
            yAxis._calculateTotals();
            this.setPrivateRaw("selectionMinY", undefined);
            this.setPrivateRaw("selectionMaxY", undefined);
            if (!outOfSelection) {
              for (var i = startIndex; i < endIndex; i++) {
                this.processYSelectionDataItem(this.dataItems[i], vcy, _stacked);
              }
            } else {
              yAxis.markDirtySelectionExtremes();
            }
          } else if (baseAxis === yAxis) {
            xAxis._calculateTotals();
            this.setPrivateRaw("selectionMinX", undefined);
            this.setPrivateRaw("selectionMaxX", undefined);
            if (!outOfSelection) {
              for (var _i = startIndex; _i < endIndex; _i++) {
                this.processXSelectionDataItem(this.dataItems[_i], vcx, _stacked);
              }
            } else {
              yAxis.markDirtySelectionExtremes();
            }
          }
          if (baseAxis === xAxis) {
            if (this.get("valueYShow") !== "valueYWorking") {
              var selectionMinY = this.getPrivate("selectionMinY");
              if (selectionMinY != null) {
                this.setPrivateRaw("minY", selectionMinY);
                yAxis.markDirtyExtremes();
              }
              var selectionMaxY = this.getPrivate("selectionMaxY");
              if (selectionMaxY != null) {
                this.setPrivateRaw("maxY", selectionMaxY);
                yAxis.markDirtyExtremes();
              }
            }
          } else if (baseAxis === yAxis) {
            if (this.get("valueXShow") !== "valueXWorking") {
              var selectionMinX = this.getPrivate("selectionMinX");
              if (selectionMinX != null) {
                this.setPrivateRaw("minX", selectionMinX);
                yAxis.markDirtyExtremes();
              }
              var selectionMaxX = this.getPrivate("selectionMaxX");
              if (selectionMaxX != null) {
                this.setPrivateRaw("maxX", selectionMaxX);
                xAxis.markDirtyExtremes();
              }
            }
          }
          if (this.isPrivateDirty("selectionMinX") || this.isPrivateDirty("selectionMaxX")) {
            xAxis.markDirtySelectionExtremes();
          }
          if (this.isPrivateDirty("selectionMinY") || this.isPrivateDirty("selectionMaxY")) {
            yAxis.markDirtySelectionExtremes();
          }
          // this.updateLegendValue(undefined); flickers while panning
        }
      }
    }
  }, {
    key: "_makeRangeMask",
    value: function _makeRangeMask() {
      var _this5 = this;
      if (this.axisRanges.length > 0) {
        var mainContainerMask = this._mainContainerMask;
        if (mainContainerMask == null) {
          mainContainerMask = this.children.push(Graphics.new(this._root, {}));
          this._mainContainerMask = mainContainerMask;
          mainContainerMask.set("draw", function (display, target) {
            var parent = _this5.parent;
            if (parent) {
              var w = _this5._root.container.width();
              var h = _this5._root.container.height();
              display.moveTo(-w, -h);
              display.lineTo(-w, h * 2);
              display.lineTo(w * 2, h * 2);
              display.lineTo(w * 2, -h);
              display.lineTo(-w, -h);
              _this5.axisRanges.each(function (axisRange) {
                var fill = axisRange.axisDataItem.get("axisFill");
                if (parent) {
                  if (fill) {
                    var draw = fill.get("draw");
                    if (draw) {
                      draw(display, target);
                    }
                  }
                }
              });
            }
            _this5.mainContainer._display.mask = mainContainerMask._display;
          });
        }
        mainContainerMask.markDirty();
        mainContainerMask._markDirtyKey("fill");
      } else {
        this.mainContainer._display.mask = null;
      }
    }
  }, {
    key: "_updateChildren",
    value: function _updateChildren() {
      _get(_getPrototypeOf(XYSeries.prototype), "_updateChildren", this).call(this);
      // save for performance
      this._x = this.x();
      this._y = this.y();
      this._makeRangeMask();
    }
  }, {
    key: "_stack",
    value: function _stack() {
      var chart = this.chart;
      if (chart) {
        var seriesIndex = chart.series.indexOf(this);
        this._couldStackTo = [];
        if (seriesIndex > 0) {
          var series;
          for (var i = seriesIndex - 1; i >= 0; i--) {
            series = chart.series.getIndex(i);
            if (series.get("xAxis") === this.get("xAxis") && series.get("yAxis") === this.get("yAxis") && series.className === this.className) {
              this._couldStackTo.push(series);
              if (!series.get("stacked")) {
                break;
              }
            }
          }
        }
        this._stackDataItems();
      }
    }
  }, {
    key: "_unstack",
    value: function _unstack() {
      var _this6 = this;
      $object.each(this._reallyStackedTo, function (_key, value) {
        delete value._stackedSeries[_this6.uid];
      });
      this._reallyStackedTo = {};
      $array.each(this.dataItems, function (dataItem) {
        dataItem.setRaw("stackToItemY", undefined);
        dataItem.setRaw("stackToItemX", undefined);
      });
    }
  }, {
    key: "_stackDataItems",
    value: function _stackDataItems() {
      var _this7 = this;
      // this works only with the same number of data @todo: search by date/category?
      var baseAxis = this.get("baseAxis");
      var xAxis = this.get("xAxis");
      var yAxis = this.get("yAxis");
      var field;
      var stackToItemKey;
      if (baseAxis === xAxis) {
        field = "valueY";
        stackToItemKey = "stackToItemY";
      } else if (baseAxis === yAxis) {
        field = "valueX";
        stackToItemKey = "stackToItemX";
      }
      var len = this._couldStackTo.length;
      var index = 0;
      var stackToNegative = this.get("stackToNegative");
      this._reallyStackedTo = {};
      $array.each(this.dataItems, function (dataItem) {
        for (var s = 0; s < len; s++) {
          var stackToSeries = _this7._couldStackTo[s];
          var stackToItem = stackToSeries.dataItems[index];
          var value = dataItem.get(field);
          if (stackToItem) {
            var stackValue = stackToItem.get(field);
            if (stackToNegative) {
              if ($type.isNumber(value)) {
                if ($type.isNumber(stackValue)) {
                  if (value >= 0 && stackValue >= 0) {
                    dataItem.setRaw(stackToItemKey, stackToItem);
                    _this7._reallyStackedTo[stackToSeries.uid] = stackToSeries;
                    stackToSeries._stackedSeries[_this7.uid] = _this7;
                    break;
                  }
                  if (value < 0 && stackValue < 0) {
                    dataItem.setRaw(stackToItemKey, stackToItem);
                    _this7._reallyStackedTo[stackToSeries.uid] = stackToSeries;
                    stackToSeries._stackedSeries[_this7.uid] = _this7;
                    break;
                  }
                }
              } else {
                break;
              }
            } else {
              if ($type.isNumber(value) && $type.isNumber(stackValue)) {
                dataItem.setRaw(stackToItemKey, stackToItem);
                _this7._reallyStackedTo[stackToSeries.uid] = stackToSeries;
                stackToSeries._stackedSeries[_this7.uid] = _this7;
                break;
              }
            }
          }
        }
        index++;
      });
    }
  }, {
    key: "processXSelectionDataItem",
    value: function processXSelectionDataItem(dataItem, vcx, stacked) {
      var _this8 = this;
      $array.each(this.__valueXShowFields, function (key) {
        var value = dataItem.get(key);
        if (value != null) {
          if (stacked) {
            value += _this8.getStackedXValueWorking(dataItem, key);
          }
          _this8._min("selectionMinX", value);
          _this8._max("selectionMaxX", value * vcx);
        }
      });
    }
  }, {
    key: "processYSelectionDataItem",
    value: function processYSelectionDataItem(dataItem, vcy, stacked) {
      var _this9 = this;
      $array.each(this.__valueYShowFields, function (key) {
        var value = dataItem.get(key);
        if (value != null) {
          if (stacked) {
            value += _this9.getStackedYValueWorking(dataItem, key);
          }
          _this9._min("selectionMinY", value);
          _this9._max("selectionMaxY", value * vcy);
        }
      });
    }
    /**
     * @ignore
     */
  }, {
    key: "getStackedYValueWorking",
    value: function getStackedYValueWorking(dataItem, key) {
      var stackToItem = dataItem.get("stackToItemY");
      if (stackToItem) {
        var stackedToSeries = stackToItem.component;
        return stackToItem.get(key, 0) * stackedToSeries.get("vcy", 1) + this.getStackedYValueWorking(stackToItem, key);
      }
      return 0;
    }
    /**
     * @ignore
     */
  }, {
    key: "getStackedXValueWorking",
    value: function getStackedXValueWorking(dataItem, key) {
      var stackToItem = dataItem.get("stackToItemX");
      if (stackToItem) {
        var stackedToSeries = stackToItem.component;
        return stackToItem.get(key, 0) * stackedToSeries.get("vcx", 1) + this.getStackedXValueWorking(stackToItem, key);
      }
      return 0;
    }
    /**
     * @ignore
     */
  }, {
    key: "getStackedYValue",
    value: function getStackedYValue(dataItem, key) {
      var stackToItem = dataItem.get("stackToItemY");
      if (stackToItem) {
        return stackToItem.get(key, 0) + this.getStackedYValue(stackToItem, key);
      }
      return 0;
    }
    /**
     * @ignore
     */
  }, {
    key: "getStackedXValue",
    value: function getStackedXValue(dataItem, key) {
      var stackToItem = dataItem.get("stackToItemX");
      if (stackToItem) {
        return stackToItem.get(key, 0) + this.getStackedXValue(stackToItem, key);
      }
      return 0;
    }
    /**
     * @ignore
     */
  }, {
    key: "createLegendMarker",
    value: function createLegendMarker(_dataItem) {
      this.updateLegendMarker();
    }
  }, {
    key: "_markDirtyAxes",
    value: function _markDirtyAxes() {
      this._axesDirty = true;
      this.markDirty();
    }
  }, {
    key: "_markDataSetDirty",
    value: function _markDataSetDirty() {
      this._afterDataChange();
      this._valuesDirty = true;
      this._dataProcessed = false;
      this._aggregatesCalculated = false;
      this.markDirty();
    }
  }, {
    key: "_clearDirty",
    value: function _clearDirty() {
      _get(_getPrototypeOf(XYSeries.prototype), "_clearDirty", this).call(this);
      this._axesDirty = false;
      this._selectionProcessed = false;
      this._stackDirty = false;
      this._dataProcessed = false;
    }
  }, {
    key: "_positionBullet",
    value: function _positionBullet(bullet) {
      var sprite = bullet.get("sprite");
      if (sprite) {
        var dataItem = sprite.dataItem;
        var locationX = bullet.get("locationX", dataItem.get("locationX", 0.5));
        var locationY = bullet.get("locationY", dataItem.get("locationY", 0.5));
        var xAxis = this.get("xAxis");
        var yAxis = this.get("yAxis");
        var positionX = xAxis.getDataItemPositionX(dataItem, this._xField, locationX, this.get("vcx", 1));
        var positionY = yAxis.getDataItemPositionY(dataItem, this._yField, locationY, this.get("vcy", 1));
        var point = this.getPoint(positionX, positionY);
        var left = dataItem.get("left", point.x);
        var right = dataItem.get("right", point.x);
        var top = dataItem.get("top", point.y);
        var bottom = dataItem.get("bottom", point.y);
        if (this._shouldShowBullet(positionX, positionY)) {
          if (!bullet.getPrivate("hidden")) {
            sprite.setPrivate("visible", true);
          } else {
            sprite.setPrivate("visible", false);
          }
          var w = right - left;
          var h = bottom - top;
          if (sprite.isType("Label")) {
            sprite.setPrivate("maxWidth", Math.abs(w));
            sprite.setPrivate("maxHeight", Math.abs(h));
          }
          var x = left + w * locationX;
          var y = bottom - h * locationY;
          sprite.set("x", x);
          sprite.set("y", y);
        } else {
          sprite.setPrivate("visible", false);
        }
      }
    }
  }, {
    key: "_shouldShowBullet",
    value: function _shouldShowBullet(_positionX, _positionY) {
      return this._showBullets;
    }
    /**
     * @ignore
     */
  }, {
    key: "setDataSet",
    value: function setDataSet(id) {
      if (this._dataSets[id]) {
        this._handleDataSetChange();
        this._dataItems = this._dataSets[id];
        this._markDataSetDirty();
        this._dataSetId = id;
        var type = "datasetchanged";
        if (this.events.isEnabled(type)) {
          this.events.dispatch(type, {
            type: type,
            target: this,
            id: id
          });
        }
      }
    }
  }, {
    key: "_handleDataSetChange",
    value: function _handleDataSetChange() {
      if (this.bullets.length > 0) {
        $array.each(this._dataItems, function (dataItem) {
          var bullets = dataItem.bullets;
          if (bullets) {
            $array.each(bullets, function (bullet) {
              if (bullet) {
                var sprite = bullet.get("sprite");
                if (sprite) {
                  sprite.setPrivate("visible", false);
                }
              }
            });
          }
        });
      }
      this._selectionProcessed = false; // for totals to be calculated
    }
    /**
     * Shows hidden series.
     *
     * @param   duration  Duration of animation in milliseconds
     * @return            Animation promise
     */
  }, {
    key: "show",
    value: function show(duration) {
      var _this10 = this;
      var _super = Object.create(null, {
        show: {
          get: function get() {
            return _get(_getPrototypeOf(XYSeries.prototype), "show", _this10);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this11 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this._fixVC();
              promises = [];
              promises.push(_super.show.call(this, duration).then(function () {
                _this11._isShowing = false;
                var xAxis = _this11.get("xAxis");
                var yAxis = _this11.get("yAxis");
                var baseAxis = _this11.get("baseAxis");
                if (yAxis !== baseAxis) {
                  yAxis.markDirtySelectionExtremes();
                }
                if (xAxis !== baseAxis) {
                  xAxis.markDirtySelectionExtremes();
                }
              }));
              promises.push(this.bulletsContainer.show(duration));
              promises.push(this._sequencedShowHide(true, duration));
              _context.next = 7;
              return Promise.all(promises);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * Hides series.
     *
     * @param   duration  Duration of animation in milliseconds
     * @return            Animation promise
     */
  }, {
    key: "hide",
    value: function hide(duration) {
      var _this12 = this;
      var _super = Object.create(null, {
        hide: {
          get: function get() {
            return _get(_getPrototypeOf(XYSeries.prototype), "hide", _this12);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this13 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this._fixVC();
              promises = [];
              promises.push(_super.hide.call(this, duration).then(function () {
                _this13._isHiding = false;
              }));
              promises.push(this.bulletsContainer.hide(duration));
              promises.push(this._sequencedShowHide(false, duration));
              _context2.next = 7;
              return Promise.all(promises);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * Shows series's data item.
     *
     * @param   dataItem  Data item
     * @param   duration  Animation duration in milliseconds
     * @return            Promise
     */
  }, {
    key: "showDataItem",
    value: function showDataItem(dataItem, duration) {
      var _this14 = this;
      var _super = Object.create(null, {
        showDataItem: {
          get: function get() {
            return _get(_getPrototypeOf(XYSeries.prototype), "showDataItem", _this14);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var promises, easing;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              promises = [_super.showDataItem.call(this, dataItem, duration)];
              if (!$type.isNumber(duration)) {
                duration = this.get("stateAnimationDuration", 0);
              }
              easing = this.get("stateAnimationEasing");
              $array.each(this._valueFields, function (key) {
                promises.push(dataItem.animate({
                  key: key + "Working",
                  to: dataItem.get(key),
                  duration: duration,
                  easing: easing
                }).waitForStop());
              });
              _context3.next = 6;
              return Promise.all(promises);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
    /**
     * Hides series's data item.
     *
     * @param   dataItem  Data item
     * @param   duration  Animation duration in milliseconds
     * @return            Promise
     */
  }, {
    key: "hideDataItem",
    value: function hideDataItem(dataItem, duration) {
      var _this15 = this;
      var _super = Object.create(null, {
        hideDataItem: {
          get: function get() {
            return _get(_getPrototypeOf(XYSeries.prototype), "hideDataItem", _this15);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var promises, hiddenState, easing, xAxis, yAxis, baseAxis, stacked, _min2, baseValue;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              promises = [_super.hideDataItem.call(this, dataItem, duration)];
              hiddenState = this.states.create("hidden", {});
              if (!$type.isNumber(duration)) {
                duration = hiddenState.get("stateAnimationDuration", this.get("stateAnimationDuration", 0));
              }
              easing = hiddenState.get("stateAnimationEasing", this.get("stateAnimationEasing"));
              xAxis = this.get("xAxis");
              yAxis = this.get("yAxis");
              baseAxis = this.get("baseAxis");
              stacked = this.get("stacked");
              if (baseAxis === xAxis || !baseAxis) {
                $array.each(this._valueYFields, function (key) {
                  var min = yAxis.getPrivate("min");
                  var baseValue = yAxis.baseValue();
                  if ($type.isNumber(min) && min > baseValue) {
                    baseValue = min;
                  }
                  if (stacked) {
                    baseValue = 0;
                  }
                  var value = dataItem.get(key);
                  if (value != null) {
                    promises.push(dataItem.animate({
                      key: key + "Working",
                      to: baseValue,
                      duration: duration,
                      easing: easing
                    }).waitForStop());
                  }
                });
              }
              if (baseAxis === yAxis || !baseAxis) {
                _min2 = xAxis.getPrivate("min");
                baseValue = xAxis.baseValue();
                if ($type.isNumber(_min2) && _min2 > baseValue) {
                  baseValue = _min2;
                }
                if (stacked) {
                  baseValue = 0;
                }
                $array.each(this._valueXFields, function (key) {
                  var value = dataItem.get(key);
                  if (value != null) {
                    promises.push(dataItem.animate({
                      key: key + "Working",
                      to: baseValue,
                      duration: duration,
                      easing: easing
                    }).waitForStop());
                  }
                });
              }
              _context4.next = 12;
              return Promise.all(promises);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "_markDirtyStack",
    value: function _markDirtyStack() {
      this._stackDirty = true;
      this.markDirty();
      this._markStakedDirtyStack();
    }
  }, {
    key: "_markStakedDirtyStack",
    value: function _markStakedDirtyStack() {
      var stackedSeries = this._stackedSeries;
      if (stackedSeries) {
        $object.each(stackedSeries, function (_key, value) {
          if (!value._stackDirty) {
            value._markDirtyStack();
          }
        });
      }
    }
  }, {
    key: "_afterChanged",
    value: function _afterChanged() {
      _get(_getPrototypeOf(XYSeries.prototype), "_afterChanged", this).call(this);
      if (this._skipped) {
        this._markDirtyAxes();
        this._skipped = false;
      }
    }
    /**
     * Shows a tooltip for specific data item.
     *
     * @param  dataItem  Data item
     */
  }, {
    key: "showDataItemTooltip",
    value: function showDataItemTooltip(dataItem) {
      this.updateLegendMarker(dataItem);
      this.updateLegendValue(dataItem);
      var tooltip = this.get("tooltip");
      if (tooltip) {
        if (!this.isHidden()) {
          tooltip._setDataItem(dataItem);
          if (dataItem) {
            var locationX = this.get("locationX", 0);
            var locationY = this.get("locationY", 1);
            var itemLocationX = dataItem.get("locationX", locationX);
            var itemLocationY = dataItem.get("locationY", locationY);
            var xAxis = this.get("xAxis");
            var yAxis = this.get("yAxis");
            var vcx = this.get("vcx", 1);
            var vcy = this.get("vcy", 1);
            var xPos = xAxis.getDataItemPositionX(dataItem, this._tooltipFieldX, this._aLocationX0 + (this._aLocationX1 - this._aLocationX0) * itemLocationX, vcx);
            var yPos = yAxis.getDataItemPositionY(dataItem, this._tooltipFieldY, this._aLocationY0 + (this._aLocationY1 - this._aLocationY0) * itemLocationY, vcy);
            var point = this.getPoint(xPos, yPos);
            var show = true;
            $array.each(this._valueFields, function (field) {
              if (dataItem.get(field) == null) {
                show = false;
              }
            });
            if (show) {
              var chart = this.chart;
              if (chart && chart.inPlot(point)) {
                tooltip.label.text.markDirtyText();
                tooltip.set("tooltipTarget", this._getTooltipTarget(dataItem));
                tooltip.set("pointTo", this._display.toGlobal({
                  x: point.x,
                  y: point.y
                }));
              } else {
                tooltip._setDataItem(undefined);
              }
            } else {
              tooltip._setDataItem(undefined);
            }
          }
        } else {
          this.hideTooltip();
        }
      }
    }
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      var tooltip = this.get("tooltip");
      if (tooltip) {
        tooltip.set("tooltipTarget", this);
      }
      return _get(_getPrototypeOf(XYSeries.prototype), "hideTooltip", this).call(this);
    }
  }, {
    key: "_getTooltipTarget",
    value: function _getTooltipTarget(dataItem) {
      if (this.get("seriesTooltipTarget") == "bullet") {
        var bullets = dataItem.bullets;
        if (bullets && bullets.length > 0) {
          var bullet = bullets[0];
          var sprite = bullet.get("sprite");
          if (sprite) {
            return sprite;
          }
        }
      }
      return this;
    }
    /**
     * @ignore
     */
  }, {
    key: "updateLegendValue",
    value: function updateLegendValue(dataItem) {
      var legendDataItem = this.get("legendDataItem");
      if (legendDataItem) {
        var label = legendDataItem.get("label");
        if (label) {
          var txt = "";
          if (dataItem) {
            label._setDataItem(dataItem);
            txt = this.get("legendLabelText", label.get("text", this.get("name", "")));
          } else {
            label._setDataItem(this._emptyDataItem);
            txt = this.get("legendRangeLabelText", this.get("legendLabelText", label.get("text", this.get("name", ""))));
          }
          label.set("text", txt);
        }
        var valueLabel = legendDataItem.get("valueLabel");
        if (valueLabel) {
          var _txt = "";
          if (dataItem) {
            valueLabel._setDataItem(dataItem);
            _txt = this.get("legendValueText", valueLabel.get("text", ""));
          } else {
            valueLabel._setDataItem(this._emptyDataItem);
            _txt = this.get("legendRangeValueText", valueLabel.get("text", ""));
          }
          valueLabel.set("text", _txt);
        }
      }
    }
  }, {
    key: "_getItemReaderLabel",
    value: function _getItemReaderLabel() {
      var text = "X: {" + this._xField;
      if (this.get("xAxis").isType("DateAxis")) {
        text += ".formatDate()";
      }
      text += "}; Y: {" + this._yField;
      if (this.get("yAxis").isType("DateAxis")) {
        text += ".formatDate()";
      }
      text += "}";
      return text;
    }
    /**
     * @ignore
     */
  }, {
    key: "getPoint",
    value: function getPoint(positionX, positionY) {
      var x = this.get("xAxis").get("renderer").positionToCoordinate(positionX);
      var y = this.get("yAxis").get("renderer").positionToCoordinate(positionY);
      // if coordinate is super big, canvas fails to draw line, capping to some big number (won't make any visual difference)
      var max = 999999999;
      if (y < -max) {
        y = -max;
      }
      if (y > max) {
        y = max;
      }
      if (x < -max) {
        x = -max;
      }
      if (x > max) {
        x = max;
      }
      return {
        x: x,
        y: y
      };
    }
  }, {
    key: "_shouldInclude",
    value: function _shouldInclude(_position) {
      return true;
    }
    /**
     * @ignore
     */
  }, {
    key: "handleCursorHide",
    value: function handleCursorHide() {
      this.hideTooltip();
      this.updateLegendValue(undefined);
      this.updateLegendMarker(undefined);
    }
  }, {
    key: "_afterDataChange",
    value: function _afterDataChange() {
      _get(_getPrototypeOf(XYSeries.prototype), "_afterDataChange", this).call(this);
      this.get("xAxis")._markDirtyKey("start");
      this.get("yAxis")._markDirtyKey("start");
      this.resetExtremes();
    }
    // todo description
  }, {
    key: "resetExtremes",
    value: function resetExtremes() {
      this.setPrivate("selectionMinX", undefined);
      this.setPrivate("selectionMaxX", undefined);
      this.setPrivate("selectionMinY", undefined);
      this.setPrivate("selectionMaxY", undefined);
      this.setPrivate("minX", undefined);
      this.setPrivate("minY", undefined);
      this.setPrivate("maxX", undefined);
      this.setPrivate("maxY", undefined);
    }
    /**
     * Creates and returns an axis range object.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-ranges/} for more info
     * @param   axisDataItem  Axis data item
     * @return                Axis range
     */
  }, {
    key: "createAxisRange",
    value: function createAxisRange(axisDataItem) {
      return this.axisRanges.push({
        axisDataItem: axisDataItem
      });
    }
    /**
     * A list of series's main (ungrouped) data items.
     *
     * @return  Data items
     */
  }, {
    key: "mainDataItems",
    get: function get() {
      return this._mainDataItems;
    }
  }]);
  return XYSeries;
}(Series);
Object.defineProperty(XYSeries, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "XYSeries"
});
Object.defineProperty(XYSeries, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Series.classNames.concat([XYSeries.className])
});